import type { HttpResponse } from "../redux/http/http.types"

export function isSuccessCode(response: HttpResponse): boolean {
  return response.status >= 200 && response.status < 300
}

export function hasFailed(response: HttpResponse, expectsData?: boolean): boolean {
  return !isSuccessCode(response) && expectsData ? response.data === undefined : false
}
